<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Kortste vorm herkennen" [steps]="assignments().length" [progress]="progress()" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="'Selecteer de kortste vorm van het woord'" />

    @for (a of [assignment()]; track a) {
      <div
        #container
        class="font-family-din absolute text-6xl select-none"
        animate.enter="wait-500 anim-pop-in"
        animate.leave="anim-fade-out"
      >
        <div
          class="flex cursor-text touch-none gap-4 px-16 text-white"
          (pointerdown)="onTextPointerDown($event)"
          (pointermove)="onTextPointerMove($event)"
          (pointerup)="onTextPointerUp($event)"
        >
          @for (letter of word(); track $index) {
            <div #letterEl [class.text-blue-400]="$index >= startIndex() && $index < endIndex()">
              {{ letter }}
            </div>
          }
        </div>

        @if (boundaryPositions().length > 0 && !isChecking()) {
          <rid-selection-handle
            animate.leave="anim-pop-out"
            [left]="startHandleLeft()"
            (dragStart)="onHandleDragStart('START')"
            (dragMove)="onHandleDragMove($event, 'START')"
            (dragEnd)="onHandleDragEnd('START')"
          />
          <rid-selection-handle
            animate.leave="anim-pop-out"
            [left]="endHandleLeft()"
            (dragStart)="onHandleDragStart('END')"
            (dragMove)="onHandleDragMove($event, 'END')"
            (dragEnd)="onHandleDragEnd('END')"
          />
        }
      </div>
    }

    @if (isSubsetSelected() && !isChecking()) {
      <rid-bottom-button content="Klaar!" (clicked)="onSubmit()" />
    }

    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
